module.exports = __webpack_public_path__ + "img/error-img-artist.0e251b0d.jpg";